/**
 * 用户端
 * */
export const Index = () => import('../views/index/index')
export const Home = () => import('../views/home/home')
export const Address = () => import('../views/home/address')
export const Screen = () => import('../views/home/screen')
export const Search = () => import('../views/home/search')
export const PositionDetails = () => import('../views/position/positionDetails')
export const ComponyDetails = () => import('../views/position/componyDetails')
export const Profile = () => import('../views/profile/profile')
export const Edit = () => import('../views/profile/edit')
export const Collect = () => import('../views/profile/collect')
export const Resume = () => import('../views/profile/resume')
export const Experience = () => import('../views/experience/experience')
export const JobSearch = () => import('../views/experience/jobSearch')
export const Interview = () => import('../views/interview/Interview')
export const ViewDetails = () => import('../views/interview/viewDetails')
export const Login = () => import('../views/login/login')
export const Account = () => import('../views/login/account')
export const SMS = () => import('../views/login/SMS')
export const ForgetPassWord = () => import('../views/login/forgetPassWord')
export const setPassWord = () => import('../views/login/setPassWord')
export const userRegister = () => import('../views/register/register')
export const soliderInfo = () => import('../views/register/soliderInfo')
export const Ideology = () => import('../views/ideology/ideology')
export const Train = () => import('../views/train/train')
export const Interpretation = () => import('../views/interpretation/interpretation')
export const Article = () => import('../views/ideology/article')
export const Artcomponent = () => import('../views/ideology/artComponent')
export const Video = () => import('../views/ideology/videoDetails')
export const Activity = () => import('../views/train/activity')
export const ActiveDetails = () => import('../views/train/activeDetails')
export const Online = () => import('../views/train/online')
export const interDetails = () => import('../views/interpretation/interDetails')
export const contant = () => import('../views/contant/contant')
export const board = () => import('../views/contant/board')

/**
 * 公司端
 * */
export const HomeBoss = () => import('../page/homeBoss/home')
export const Register = () => import('../page/logReg/register')
export const Information = () => import('../page/logReg/information')
export const Ment = () => import('../page/management/management')
export const EditPosition = () => import('../page/management/editPosition')
export const Description = () => import('../page/management/description')
export const interviewResult = () => import('../page/management/interviewResult')
export const Recommend = () => import('../page/recommend/recommend')
export const jobSearch = () => import('../page/homeBoss/jobSearch')
export const ResumeDetails = () => import('../page/recommend/details')
export const Mine = () => import('../page/mine/mine')
export const companyInvite = () => import('../views/profile/company')

// 生活服务
export const life = () => import('../views/life/life')
